// extracted by mini-css-extract-plugin
export var orderDetails = "_pi-2";
export var orderImage = "_pi-1";
export var orderMeta = "_pi-3";
export var orderSummary = "_pi-0";
export var rightArrow = "_pi-4";